import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoSection() {
  const isFor = ['Empleados con un trabajo de 9 a 5 que necesitan un ingreso extra urgente.', 'Emprendedores que se sienten intimidados por la tecnología.', 'Personas que tienen una idea pero no saben cómo dar el primer paso técnico.', 'Latinos en USA que quieren aprovechar el mercado de mayor consumo del mundo.'];
  const notFor = ['Personas que buscan una fórmula mágica para hacerse millonarios sin trabajar.', 'Perfeccionistas extremos que prefieren un diseño bonito a una venta real.', 'Quienes no están dispuestos a dedicarle un fin de semana intenso a su proyecto.'];
  return <section className="py-20 bg-white px-4" data-id="element-199">
      <div className="max-w-6xl mx-auto" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900" data-id="element-202">
            ¿Para Quién Es Este Sistema?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-203">
          {/* Who it is for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-green-50 rounded-2xl p-8 border-2 border-green-100" data-id="element-204">
            <h3 className="text-3xl font-bold text-green-800 mb-8 flex items-center gap-3" data-id="element-205">
              <span className="bg-green-200 p-2 rounded-full" data-id="element-206">
                <CheckIcon className="w-8 h-8 text-green-700" data-id="element-207" />
              </span>
              ESTO SÍ ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-208">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-209">
                  <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-210" />
                  <span className="text-lg text-gray-800 font-medium" data-id="element-211">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who it is NOT for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-red-50 rounded-2xl p-8 border-2 border-red-100" data-id="element-212">
            <h3 className="text-3xl font-bold text-red-800 mb-8 flex items-center gap-3" data-id="element-213">
              <span className="bg-red-200 p-2 rounded-full" data-id="element-214">
                <XIcon className="w-8 h-8 text-red-700" data-id="element-215" />
              </span>
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-216">
              {notFor.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-217">
                  <XIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-218" />
                  <span className="text-lg text-gray-800 font-medium" data-id="element-219">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}